export const permission = [
     {
        
        modules: "Dashboard",
        created: "",
        view: "",
        edit: "",
        delete: "",
        allowAll: ""
    },
    {
        
        modules: "Centers",
        created: "",
        view: "",
        edit: "",
        delete: "",
        allowAll: ""
    },
    {
        
        modules: "Users",
        created: "",
        view: "",
        edit: "",
        delete: "",
        allowAll: ""
    },
    {
        
        modules: "Attendence",
        created: "",
        view: "",
        edit: "",
        delete: "",
        allowAll: ""
    },
     {
        
        modules: "Records",
        created: "",
        view: "",
        edit: "",
        delete: "",
        allowAll: ""
    },
     {
        
        modules: "Meal",
        created: "",
        view: "",
        edit: "",
        delete: "",
        allowAll: ""
    },
     {
        
        modules: "Communication",
        created: "",
        view: "",
        edit: "",
        delete: "",
        allowAll: ""
    },
     {
        
        modules: "Records",
        created: "",
        view: "",
        edit: "",
        delete: "",
        allowAll: ""
    },
    {
        
        modules: "Live Cctv",
        created: "",
        view: "",
        edit: "",
        delete: "",
        allowAll: ""
    },
    {
        
        modules: "SubscriptionPlans",
        created: "",
        view: "",
        edit: "",
        delete: "",
        allowAll: ""
    },
    {
        
        modules: "AccessControl",
        created: "",
        view: "",
        edit: "",
        delete: "",
        allowAll: ""
    },
     
  ];
  